import * as React from 'react'
import { css } from 'glamor'
export const yourContact: React.CSSProperties = {
    borderColor: 'lightgreen',
    borderRadius: '25px 25px 25px 0px',
    borderStyle: 'solid',
    borderWidth: '2em !important',
    margin: '20px',
    padding: '20px',
    textAlign: 'left',
    width: '70%'
}
export const contactDate: React.CSSProperties = {
    fontSize: '0.8em',
    fontStyle: 'italic'
}


export const contactButtons: React.CSSProperties = {
    fontSize: '160px'
}




export const myContact: React.CSSProperties = {
    borderColor: 'lightblue',
    borderStyle: 'solid',
    borderRadius: '25px 25px 0px 25px',
    margin: '20px',
    padding: '20px',
    textAlign: 'right'
}

export const myContactParent: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: '3fr 7fr',

}



export const rightContact: React.CSSProperties = css({
    borderColor: 'lightblue',
    borderStyle: 'solid',
    borderRadius: '25px 25px 0px 25px',
    margin: '20px',
    padding: '20px',
    textAlign: 'right',
    'html.ie9 & span': { fontSize: '0.8em', fontStyle: 'italic', textAlign: 'right' },
    'html.ie9 & span.date': { fontSize: '0.8em', fontStyle: 'italic', float: "right" },
})



const itemContact = css({
    borderColor: 'lightgreen',
    borderRadius: '25px 25px 25px 0px',
    borderStyle: 'solid',
    // borderWidth: '2em !important',
    float: "left",
    margin: '20px',
    padding: '20px',
    textAlign: 'left',
    width: '70%',
    ' div.contact-header': {
        borderBottomColor: "#eee",
        borderBottomWidth: "1px",
        borderBottomStyle: "solid",
        marginTop: "1rem",
        marginBottom: "1rem",
        paddingBottom: "10px",
    },
    ' div.contact-body': {

    },
    ' span.date': { fontSize: '0.8em', fontStyle: 'italic', textAlign: 'left' },
    ' span.closed-in': { float: "right" },
    ":after": {
        display: "block",
        clear: "both",
        content: " "
    },
    ":before": {
        display: "block",
        clear: "both",
        content: " "
    }
})

const right: React.CSSProperties = css({
    borderColor: 'lightblue',
    borderStyle: 'solid',
    borderRadius: '25px 25px 0px 25px',
    margin: '20px',
    padding: '20px',
    float: "right",
    textAlign: 'right',
    ' span.date': { fontSize: '0.8em', fontStyle: 'italic', textAlign: 'right' },
    ' span.closed-in': { float: "left" },

})


export const styles = {
    itemContact: itemContact,
    right: right
}